// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__369l2","left":"styles_left__2gg26"};